import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getUserEmail } from '@/services/authentication';
import { stripeSuccessSubscriptionRequest } from '../freeTrialActions';

export default function StripeRedirect() {
	const navigate = useHistory();
	const dispatch = useDispatch();

	const { search } = window.location;
	const params = new URLSearchParams(search);
	const sessionId = params.get('session_id');

	const stripeSuccess = (sessionId: string) => {
		dispatch(stripeSuccessSubscriptionRequest(sessionId));
	};

	const email = getUserEmail();

	useEffect(() => {
		if (email) {
			navigate.push('/');
			return;
		}
		if (!sessionId) {
			window.location.assign(
				`${process.env.REACT_BACKEND_HOST}:${process.env.REACT_BACKEND_PORT}/api/trial/createCheckoutSession`
			);
			return;
		}

		try {
			stripeSuccess(sessionId);
			navigate.push('/');
		} catch (err) {
			console.log(err);
			navigate.push('/');
		}
	}, []);

	return <></>;
}
